import type { PRMSearchProps } from './PRMSearchTypes';
import './PRMSearch.scss';

const PRMSearch = ({ value, onChange, placeholder = 'Search', label = 'Search' }: PRMSearchProps) => (
  <div className="prmSearch">
    <input
      type="search"
      className="form-control"
      aria-label={label}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
    {value && (
      <button
        type="button"
        className="prmSearch-clear"
        aria-label="Clear search"
        title="Clear search"
        onClick={() => onChange('')}
      >
        <i className="icon-Delete-circle" aria-hidden="true"></i>
      </button>
    )}
  </div>
);

export default PRMSearch;
